import React from 'react';
import { useSelector } from 'react-redux';

import { adaptTaxonomyContextToBreadcrumbs } from 'src/adapters/storeToUI/adaptTaxonomyContextToBreadcrumbs';
import { BreadcrumbsContainer } from 'src/components/molecules/Breadcrumbs/BreadcrumbsContainer';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectMatchedTaxonomyEntry } from 'src/redux/content/selectors/selectMatchedTaxonomyEntry';
import { selectTaxonomyContext } from 'src/redux/productsQuery/selectors/selectTaxonomyContext';

export const TaxonomyBreadcrumbsContainer = () => {
  const context = useSelector((state: ReduxApplicationState) => selectTaxonomyContext(state));
  const matchedEntry = useSelector(selectMatchedTaxonomyEntry);
  const links = adaptTaxonomyContextToBreadcrumbs(context, matchedEntry);

  if (!links || links.length === 0) {
    return null;
  }

  return <BreadcrumbsContainer breadcrumbsLinks={links} includesCurrentPage />;
};
